/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 競合の種類（競合していない、削除されている、編集されている）
 * @export
 * @enum {string}
 */
export enum ConflictType {
    None = 'none',
    Deleted = 'deleted',
    Edited = 'edited'
}

export function ConflictTypeFromJSON(json: any): ConflictType {
    return ConflictTypeFromJSONTyped(json, false);
}

export function ConflictTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConflictType {
    return json as ConflictType;
}

export function ConflictTypeToJSON(value?: ConflictType | null): any {
    return value as any;
}

